import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { fetchRoutes } from './api';
import Home from './components/Home';

const RedirectPage = () => {
    // Redirect after rendering this component
     window.location.href="https://google.com";
  };

  const DynamicRoutePage = ({ dynamicData }) => {
    window.location.href=dynamicData;
  };

const App = () => {

    
  const [routes, setRoutes] = useState([]);
  const getRoutes = async () => {
    const fetchedRoutes = await fetchRoutes();
    if (Array.isArray(fetchedRoutes)) {
        setRoutes(fetchedRoutes);
    } else {
        console.error("API response is not an array:", fetchedRoutes);
        setRoutes([]); // Fallback to an empty array
    }
};

    useEffect(() => {
      const getRoutes = async () => {
          const fetchedRoutes = await fetchRoutes();
          console.log("Fetched routes:", fetchedRoutes); // Debugging
          setRoutes(fetchedRoutes);
      };
  
      getRoutes();
  }, []);
  


    return (
        <Router>
            <Routes>
                <Route path="/contact/:userId" element={<RedirectPage />} />
                {routes.map((route) => (
                    <Route
                        key={route.route}
                        path={`/${route.route}:userId`}
                        element={<DynamicRoutePage dynamicData={route.link} />} 
                    />
                ))}
            </Routes>
        </Router>
    );
};

export default App;
